import { PayloadAction, createSlice } from '@reduxjs/toolkit';
import { LatLngExpression } from 'leaflet';
import { getPersistedData, setPersistedData } from '@casops/shared/utils/persistedData';

export const latlngAustralia: LatLngExpression = [-26.391869671769022, 133.6376953125];
export const fallbackZoom = 5;

export interface MapData {
  centreLat: number;
  centreLon: number;
  zoom: number;
}

const fallbackMapData: MapData = {
  centreLat: latlngAustralia[0],
  centreLon: latlngAustralia[1],
  zoom: fallbackZoom,
};

// Type guard to validate local storage data.
function isMapData(data: unknown): data is MapData {
  return (
    data instanceof Object &&
    'centreLat' in data &&
    typeof data.centreLat === 'number' &&
    'centreLon' in data &&
    typeof data.centreLon === 'number' &&
    'zoom' in data &&
    typeof data.zoom === 'number'
  );
}

const storageKey = 'mapview';

const mapSlice = createSlice({
  name: 'map',
  initialState: getPersistedData({ storageKey, typeGuard: isMapData }) ?? fallbackMapData,
  reducers: {
    setView: (state, action: PayloadAction<MapData>) => {
      setPersistedData({ storageKey, data: action.payload });

      return {
        ...state,
        ...action.payload,
      };
    },
  },
});

export const { setView } = mapSlice.actions;
export default mapSlice.reducer;
